import styled from "styled-components";
export const HeaderContentWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 20px;

    @media (min-width: 992px) {
        flex-direction: row;
        align-items: center;
        margin-bottom: 30px;
    }
    button {
        width: 100%;
    }
    .left-wrap {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;

        @media (min-width: 768px) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
        @media (min-width: 992px) {
            gap: 20px;
        }

        .heading {
            font-size: 16px;
            line-height: 20px;
            font-weight: 300;

            @media (min-width: 768px) {
                font-size: 18px;
                line-height: 22px;
                white-space: nowrap;
            }
        }
    }
    .date-wrap {
        display: flex;
        justify-content: start;
        align-items: flex-start;
        gap: 20px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        color: black;
        flex-direction: column;

        @media (min-width: 576px) {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }
        .dateHolder {
            display: flex;
            align-items: center;
            gap: 6px;
            @media (min-width: 768px) {
                gap: 20px;
            }
        }
        .date {
            width: 100%;
            max-width: 140px;
            input {
                padding: 0 10px;
            }
        }
    }
    .dropdownWrap {
        position: relative;
        width: 100%;
        max-width: 244px;
        .dropdownBtn {
            cursor: pointer;
            display: flex;
            gap: 5px;
            align-items: center;
            justify-content: space-between;
            background-color: ${({theme}) => theme?.light?.primary};
            border-radius: 14px;
            padding: 10px;
            .heading {
                font-size: 14px;
                line-height: 18px;
                font-weight: 300;
                color: var(--white);
                white-space: nowrap;
            }
        }
    }
`;
export const DropDown = styled.div`
    position: absolute;
    top: 45px;
    right: 0;
    background-color: var(--white);
    width: ${({width}) => (width ? width : "197px")};
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    opacity: 0;
    border-radius: 10px;
    visibility: hidden;
    transform: translateY(30px);
    transition: 0.4s;
    z-index: 1;
    .label {
        span {
            svg {
                width: 20px;
                height: 20px;
            }
        }
    }
    &.active {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
    }
    .form {
        padding: 10px 15px;
    }

    .col {
        gap: 10px;
        padding: 8px 0;
    }
`;
